import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full p-6 rounded-xl bg-gradient-to-br from-primary/5 to-accent/5 border border-border">
      <div className="flex flex-col items-center text-center gap-4">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="UserPlus" size={28} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            New to TrainaryGym?
          </h3>
          <p className="text-sm text-muted-foreground max-w-md">
            Join our fitness community today and start your journey to a healthier lifestyle
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => navigate('/member-registration')}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Register as New Member
        </Button>
      </div>
    </div>
  );
};

export default RegistrationPrompt;